import { useAppBootstrapViewModel } from "@/betby/viewmodels/useAppBootstrapViewModel";

const SDKInit = ({ children }: { children: React.ReactNode }) => {
  const { isReady } = useAppBootstrapViewModel();

  if (!isReady) {
    return null;
  }

  return <>{children}</>;
};

export default SDKInit;
